(() => {
  const hostSelector = '#mcforms-410624-487982';
  const styleId = 'speciality-mobile-claim-tab';
  const attached = new WeakSet();
  const css = `
    @media screen and (max-width: 699px) {
      #el_0g9s77xVyC {
        min-height: 44px !important;
        height: auto !important;
        padding: 13px 12px 13px 44px !important;
      }
      #el_IUudieFlGo {
        font-size: 14px !important;
        line-height: 18px !important;
      }
      #el_iJeMKSLAPa {
        box-sizing: border-box !important;
        width: 44px !important;
        height: 44px !important;
        left: 0 !important;
        padding: 15px !important;
      }
    }
  `;

  const attach = (host) => {
    const root = host.shadowRoot;
    if (!root || attached.has(root)) return;
    attached.add(root);

    const ensureStyle = () => {
      if (root.getElementById(styleId)) return;
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.append(style);
    };

    ensureStyle();
    new MutationObserver(ensureStyle).observe(root, { childList: true });
  };

  document.querySelectorAll(hostSelector).forEach(attach);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(hostSelector)) attach(node);
        node.querySelectorAll(hostSelector).forEach(attach);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
